// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable radix */
import Cookies from "js-cookie" // undocumented cookies

import { get } from "../../utils/get"
import type { WindowType } from "../../consts/windowConsts"
import { TYPES } from "../../consts/windowConsts"

type Banner = {
  showOnMobile: boolean
}

export const hashBannerText = (text: string): string =>
  // @ts-expect-error: Flow to TS migration.
  `${text[0]}_${text[parseInt(text.length / 5)]}_${text[parseInt(text.length / 2)]}_${
    text[text.length - 1]
  }}`

export const shouldShowAlert = (windowType: WindowType, banner: Banner): boolean =>
  !(windowType === TYPES.MOBILE && !banner.showOnMobile)

export const handleClosedBannerCookies = (index: number): void => {
  const cookiesClosedBanners = Cookies.getJSON("closedBanners") || []
  // @ts-expect-error: Flow to TS migration.
  const state = window.reduxStore.getState()
  const closedBanner = hashBannerText(
    get(["remoteConfig", "bannersConfig", "banners", index, "text"], state),
  )
  Cookies.set("closedBanners", JSON.stringify([closedBanner].concat(cookiesClosedBanners)), {
    expires: 1,
  })
}
